import { gql } from '../__generated__';

export const MOST_VISITED_COMPANIES_QUERY = gql(`
  query xcpMostVisitedCompanies(
    $limit: Int
    $offset: Int
    $order: MostVisitedCompaniesOrder
  ) {
    mostVisitedCompanies(limit: $limit, offset: $offset, order: $order) {
      total
      collection {
        company {
          ...CompanyData
        }
      }
    }
  }
`);
